import getMailActionCustomData from 'mini-mail-list-store/lib/utils/getMailActionCustomData';
import loadMoreInMailTable from './loadMoreInMailTable';
import { ACTION_LOAD_MORE_IN_TABLE } from './../../utils/actionNames';
import { lazyLoadMoreInSearchTable } from 'mini-mail-search-actions';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import { wrapFunctionForDatapoint } from 'owa-analytics';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

export default wrapFunctionForDatapoint(
    { name: ACTION_LOAD_MORE_IN_TABLE, customData: getMailActionCustomData() },
    function loadMoreInTable(tableView: TableView): Promise<void> {
        if (!tableView) {
            throw new Error('Selected tableview must not be null if loadMoreRows is being called.');
        }

        switch (tableView.tableQuery.type) {
            case 0:
                return loadMoreInMailTable(tableView);
            case 1:
                return lazyLoadMoreInSearchTable.importAndExecute(tableView);
            default:
                return Promise.resolve();
        }
    }
);
